export default class RouteNotFoundError extends Error {
  constructor() {
    super('Route non trouvée.')
    this.name = 'RouteNotFoundError'
  }
}
